import Logger from 'utils/logger';
import config from 'config';
import { User } from 'types/User';
import { Account } from 'types/Account';

declare global {
  interface Window {
    beamer_config?: {
      product_id: string;
      button?: boolean;
      counter?: boolean;
      selector?: string;
      user_id?: string;
      user_firstname?: string;
      user_lastname?: string;
      user_email?: string;
    };
    Beamer?: {
      init: () => void;
      update: (config: Record<string, unknown>) => void;
      show: () => void;
      hide: () => void;
      toggle: () => void;
    };
  }
}

const BeamerUtils = {
  shouldSkip() {
    return !config.BEAMER_PRODUCT_ID;
  },
  init(user: User, account: Account) {
    try {
      if (this.shouldSkip()) {
        Logger.log('Skipping Beamer initialization');
        return;
      }

      window.beamer_config = {
        product_id: config.BEAMER_PRODUCT_ID,
        button: false,
        counter: true,
        selector: '.beamerTrigger',
        user_id: `${account.publicId}-${user.id}`,
        user_firstname: user.name,
        user_lastname: user.surname,
        user_email: user.email,
      };

      if (!document.querySelector('script[src*="beamer-embed"]')) {
        const script = document.createElement('script');
        script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
        script.async = true;
        document.body.appendChild(script);
      }
    } catch (e) {
      Logger.error(e);
    }
  },
};

export default BeamerUtils;
